// Import old scripts as a raw string, then execute it once so it populates the window object
import {getLeaderboard} from "./modules/leaderboard-tree";

const init = require('!!raw-loader!./init-window.js');

eval.call(null, init.default);

//Before commit, remove comment
import {initTabs} from "./modules/steps";

import {initLeaderboardMobileSlider} from "./sliders";
import {observer} from "./modules/landing-page";
import {replaceVerificationNumber} from "./modules/verification-page";
import {Vimeo} from "../assets/js/player";
import {closeModal, openModal} from "./modules/overview-videos";
import './formValidation';

const onGlobalLoad = function() {

	window.replaceVerificationNumber = replaceVerificationNumber;
	window.closeModal = closeModal;
	window.openModal = openModal;

	var leaderboard = document.getElementById("leaderboard-tree");
	var steps = document.getElementById("theNegotiatorsStepsPage");
	var signUpContainer = document.getElementById("signUpContainer");
	var videoIframeOne = document.getElementById("modalOverviewVideoOne");
	var videoIframeTwo = document.getElementById("modalOverviewVideoTwo")
	var overview = document.getElementById("overviewContainer"); 
	

	if (steps) {
		initTabs();
	}

	if (leaderboard) {
		getLeaderboard();
		initLeaderboardMobileSlider();
	}
	if (signUpContainer) {
		observer.observe(document.querySelector('.landing-page-sign-up-container'));
	}

	if (overview) {
		const playerOne = new Vimeo.Player(videoIframeOne);
		const playerTwo = new Vimeo.Player(videoIframeTwo);
	}
}



// PRODUCTION is set in webpack.prod.js or webpack.dev.js
if (PRODUCTION) {
	onGlobalLoad();

} else {

	// for dev only
	window["afterInclude"] = function () {
		onGlobalLoad();

	};
}
